<template>
  <div>
    <section class="hero">
      <div class="hero-body">
        <div class="columns">
          <div class="column is-6">
            <p class="title">{{ i18n.folios[iso] }}</p>
            <p class="subtitle is-6">{{ i18n.disponible[iso] }}: <strong>{{ balance.disponible }}</strong></p>
          </div>
          <div class="column is-3">
            <b-button
              icon-left="sync"
              icon-pack="fas"
              type="is-light"
              @click="onRefresh()"
              >{{ i18n.refresh[iso] }}</b-button
            >
          </div>
        </div>
      </div>
    </section>

    <b-tabs v-model="activeTab">
      <b-tab-item>
        <template #header>
          <b-icon icon="ticket-alt" pack="fas" type="is-info"></b-icon>
          <b>{{ i18n.folios[iso] }}</b>
        </template>

        <div class="columns is-multiline">
          <div
            class="column is-3"
            v-for="pack in packs"
            :key="pack.Pack"
            v-if="$checkPermission('cap-folios-buy')"
          >
            <div class="card">
              <div class="card-content has-text-centered">
                <p class="title is-4">{{ pack.Cantidad }}</p>
                <p class="subtitle is-6">US$ {{ pack.Cantidad * pack.PrecioUnitario }}</p>
              </div>
          <footer class="card-footer">
            <a
              class="card-footer-item"
              :class="{ 'has-text-grey': isLoadingBuy !== null }"
              @click="buyFolios(pack.Pack)"
            >
              <span style="color: #48c78e; font-weight: bold">{{
                i18n.buy[iso]
              }}</span>
              <b-icon
                pack="fas"
                :icon="isLoadingBuy === pack.Pack ? 'sync-alt' : 'shopping-cart'"
                :type="isLoadingBuy === pack.Pack ? 'is-info' : 'is-success'"
                :custom-class="isLoadingBuy === pack.Pack ? 'fa-spin' : ''"
              ></b-icon>
            </a>
          </footer>
            </div>
          </div>
        </div>

        <div class="columns is-multiline">
          <div class="column is-12">
            <b-table
              :data="balance.purchases"
              :loading="isLoading"
              paginated
              per-page="10"
              :card-layout="false"
            >
              <b-table-column field="FolioCompra" :label="i18n.folioCompra[iso]">
                <template v-slot="props">{{ props.row.FolioCompra }}</template>
              </b-table-column>
              <b-table-column field="Pack" :label="i18n.pack[iso]">
                <template v-slot="props">{{ props.row.Pack }}</template>
              </b-table-column>
              <b-table-column field="Cantidad" :label="i18n.quantity[iso]">
                <template v-slot="props">{{ props.row.Cantidad }}</template>
              </b-table-column>
              <b-table-column field="Total" :label="i18n.total[iso]">
                <template v-slot="props">US$ {{ props.row.Total }}</template>
              </b-table-column>
              <b-table-column field="Estado" :label="i18n.status[iso]">
                <template v-slot="props">
                  <b-tag :type="props.row.Estado === 'paid' ? 'is-success' : 'is-warning'">
                    {{ props.row.Estado }}
                  </b-tag>
                </template>
              </b-table-column>
              <b-table-column field="FechaPago" :label="i18n.date[iso]">
                <template v-slot="props">{{
                  props.row.FechaPago ? moment(props.row.FechaPago).format("DD-MM-YYYY HH:mm") : "—"
                }}</template>
              </b-table-column>
            </b-table>
           </div>
         </div>
       </b-tab-item>

      <b-tab-item>
        <template #header>
          <b-icon icon="certificate" pack="fas" type="is-success"></b-icon>
          <b>{{ i18n.emittedCertificates[iso] }}</b>
          <b-button
            size="is-small"
            icon-left="plus"
            icon-pack="fas"
            type="is-success"
            style="margin-left: 0.75em"
            @click.native.stop="openModalCert()"
          >{{ i18n.issueCertificate[iso] }}</b-button>
        </template>
        <div class="columns is-multiline filter-compact">
          <div class="column is-3">
            <b-field :label="i18n.folioCompra[iso] " label-position="on-border">
              <b-input v-model="certFilters.Folio" type="text" expanded></b-input>
            </b-field>
          </div>
          <div class="column is-3">
            <b-field :label="i18n.email[iso]" label-position="on-border">
              <b-input v-model="certFilters.Email" type="text" expanded></b-input>
            </b-field>
          </div>
          <div class="column is-3">
            <b-field :label="i18n.name[iso]" label-position="on-border">
              <b-input v-model="certFilters.Nombre" type="text" expanded></b-input>
            </b-field>
          </div>
          <div class="column is-3">
            <b-button
              icon-left="search"
              icon-pack="fas"
              type="is-info"
              expanded
              @click="listCertificates()"
            >{{ i18n.search[iso] }}</b-button>
            <b-button
              icon-left="eraser"
              icon-pack="fas"
              type="is-danger is-light"
              expanded
              @click="clearCertFilters()"
            >{{ i18n.resetSearch[iso] }}</b-button>
          </div>
        </div>

        <div class="columns is-multiline">
          <div class="column is-12">
            <b-table
              :data="certificates"
              :loading="isLoadingCerts"
              paginated
              per-page="10"
              :card-layout="false"
            >
              <b-table-column field="Codigo" :label="i18n.code[iso]">
                <template v-slot="props">
                  <b-tag>{{ props.row.Codigo[0] }}</b-tag>
                </template>
              </b-table-column>
              <b-table-column field="Nombre" :label="i18n.client[iso]">
                <template v-slot="props">{{ props.row.Nombre }}</template>
              </b-table-column>
              <b-table-column field="Email" :label="i18n.email[iso]">
                <template v-slot="props">{{ (props.row.Email && props.row.Email[0]) || '—' }}</template>
              </b-table-column>
              <b-table-column field="Estado" :label="i18n.status[iso]">
                <template v-slot="props">
                  <b-tag
                    :type="certEstadoTagType(props.row.Estado)"
                  >{{ props.row.Estado }}</b-tag>
                </template>
              </b-table-column>
              <b-table-column field="FechaCreacion" :label="i18n.date[iso]">
                <template v-slot="props">{{
                  props.row.FechaCreacion ? moment(props.row.FechaCreacion).format("DD-MM-YYYY HH:mm") : "—"
                }}</template>
              </b-table-column>
            </b-table>
          </div>
        </div>
      </b-tab-item>
    </b-tabs>
  </div>
</template>

<script>
import i18n from "../../utils/i18n";
import axios from "axios";
import moment from "moment";
const API_URL = process.env.VUE_APP_API_URL;

export default {
  data() {
    return {
      iso: "en",
      i18n,
      moment,
      club: null,
      activeTab: 0,
      isLoading: false,
      isLoadingBuy: null,
      isLoadingCerts: false,
      packs: [],
      balance: {
        disponible: 0,
        packs: [],
        purchases: [],
      },
      certificates: [],
      certFilters: {
        Folio: null,
        Email: null,
        Nombre: null,
      },
    };
  },
  async created() {
    this.iso = localStorage.getItem("iso") || "en";
    this.club = JSON.parse(localStorage.getItem("club")) || {};
    this.$bus.on("folios-balance-refresh", this.onRefresh);
    window.addEventListener("focus", this.onRefresh);
    await Promise.all([this.getBalance(), this.listCertificates()]);
  },
  beforeDestroy() {
    this.$bus.off("folios-balance-refresh", this.onRefresh);
    window.removeEventListener("focus", this.onRefresh);
  },
  methods: {
    onRefresh() {
      this.getBalance();
      this.listCertificates();
    },
    openModalCert() {
      this.$bus.emit("open-modal-cert");
    },
    async getBalance() {
      try {
        this.isLoading = true;
        const { data } = await axios.get(`${API_URL}/folios/balance`, {
          params: { ClubId: this.club.Id },
        });
        this.balance = {
          disponible: data.disponible,
          packs: data.packs,
          purchases: data.purchases,
        };
        this.packs = data.packs;
        this.isLoading = false;
      } catch (err) {
        console.log(err);
        this.isLoading = false;
        const msg = err?.response?.data?.message;
        this.$buefy.toast.open({
          message: msg || "Error",
          type: "is-danger",
        });
      }
    },
    async buyFolios(pack) {
      if (this.isLoadingBuy !== null) return; // evita sesiones dobles
      try {
        this.isLoadingBuy = pack;
        const { data } = await axios.post(`${API_URL}/folios/purchase`, {
          ClubId: this.club.Id,
          Pack: pack,
          CreadoPor: localStorage.getItem("user"),
        });
        this.isLoadingBuy = null;
        // Abrir el checkout de Stripe en una nueva ventana
        if (data.checkoutUrl) {
          window.open(data.checkoutUrl, "_blank");
        }
      } catch (err) {
        console.log(err);
        this.isLoadingBuy = null;
        const msg = err?.response?.data?.message;
        this.$buefy.toast.open({
          message: msg || "Error",
          type: "is-danger",
        });
      }
    },
    async listCertificates() {
      try {
        this.isLoadingCerts = true;
        const payload = { ClubId: this.club.Id };
        if (this.certFilters.Folio) payload.Codigo = this.certFilters.Folio;
        if (this.certFilters.Email) payload.Email = this.certFilters.Email;
        if (this.certFilters.Nombre) payload.Nombre = this.certFilters.Nombre;
        const { data } = await axios.post(`${API_URL}/cupones/list-from-folio`, payload);
        this.certificates = data.cupones || [];
        this.isLoadingCerts = false;
      } catch (err) {
        console.log(err);
        this.isLoadingCerts = false;
        this.certificates = [];
      }
    },
    clearCertFilters() {
      this.certFilters = { Folio: null, Email: null, Nombre: null };
      this.listCertificates();
    },
    certEstadoTagType(estado) {
      switch (estado) {
        case "active":
          return "is-success";
        case "pending":
          return "is-warning";
        default:
          return "is-light";
      }
    },
  },
};
</script>
